import React from 'react';

import type {IconProps} from '../types';
import {colourMap, sizesMap} from '../utils/iconProperties';

const SortIcon = ({
  size = 'small',
  colour = 'textPrimary',
  alt,
}: IconProps): JSX.Element => (
  <svg
    aria-hidden={!alt ? true : undefined}
    aria-label={alt}
    role={alt ? 'img' : undefined}
    width={sizesMap[size]}
    height={sizesMap[size]}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.9923 9.64492L9.05306 7.7057L9.05306 20.1138H6.05306L6.05307 7.73515L4.14329 9.64492L2.02197 7.5236L7.56779 1.97778L13.1136 7.5236L10.9923 9.64492Z'
      fill={colourMap[colour]}
    />
    <path
      d='M13.1433 14.4467L15.0825 16.3859L15.0825 3.97783H18.0825L18.0825 16.3565L19.9923 14.4467L22.1136 16.568L16.5678 22.1139L11.022 16.568L13.1433 14.4467Z'
      fill={colourMap[colour]}
    />
  </svg>
);

export default SortIcon;
